import type { InputHTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';
import type { FieldValues, Path, UseFormRegister } from 'react-hook-form';

interface RadioButtonProps<T extends FieldValues> extends InputHTMLAttributes<HTMLInputElement> {
  registerName: Path<T>;
  register: UseFormRegister<T>;
  label: string;
  value: string;
}

export const RadioButton = <T extends FieldValues>({ registerName, register, label, value, disabled }: RadioButtonProps<T>) => {
  const { t } = useTranslation();
  const inputId = `${value}-input`;

  return (
    <div className="flex items-center">
      <input {...register(registerName)} type="radio" id={inputId} value={value} className="mr-2" disabled={disabled} />
      <label htmlFor={inputId}>{t(label)}</label>
    </div>
  );
};
